import { PrimitiveValueObjectDate } from '@/domain/primitiveValueObjectDate';

/**
 * 欠席日
 */
export class AbsenceDate extends PrimitiveValueObjectDate {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): AbsenceDate {
    return new AbsenceDate(value);
  }

  /** ラベル */
  static get label(): string {
    return '欠席日';
  }

  /** バリデーションルール */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
      /** バリデーション */
      validate: {
        /** メッセージ */
        message: (v: string) => {
          const now = new Date();
          const tmp = v.split('-');
          const num = parseInt(`${tmp[0]}${tmp[1]}${tmp[2]}`, 10);
          let numNow = now.getFullYear() * 10000;
          numNow += (now.getMonth() + 1) * 100;
          numNow += now.getDate();
          if (num < numNow) {
            return '過去の連絡はできません';
          }
          return null;
        },
      },
    };
  }

  /**
   * 比較日より前かチェックします.
   * @param date 比較日
   * @returns 比較日より前か
   */
  isPastDate(date: Date) {
    let valueNum = this.value.getFullYear() * 10000;
    valueNum += this.value.getMonth() * 100;
    valueNum += this.value.getDate();
    let dateNum = date.getFullYear() * 10000;
    dateNum += date.getMonth() * 100;
    dateNum += date.getDate();
    return valueNum < dateNum;
  }
}
